export default __webpack_public_path__ + "static/okr-framework-0807408ae723832445634324b87a75bb.mp4";